<template>
  <van-popup
    v-model="kaiguan"
    round
    :style="{background:'transparent'}"
    @click-overlay="closeLogin"
  >
    <div class="bingo">
      <div class="box-content">
        <p class="title" v-if="gift.from">请填写完整信息</p>
        <p class="title" v-else>恭喜获得{{gift.prize}}</p>
        <div class="input-box van-hairline--surround mb2">
          <div class="input-title">收件人:</div>
          <div class="input-msg">
            <input type="text" placeholder="请输入收件人信息" v-model="username" />
          </div>
        </div>
        <div class="input-box van-hairline--surround mb2">
          <div class="input-title">手机号:</div>
          <div class="input-msg">
            <input type="text" placeholder="请输入您的手机号" v-model="phone_number" maxlength="20" />
          </div>
        </div>
        <div class="input-box van-hairline--surround mb4" v-if="gift.prize === '京东卡'">
          <div class="input-title">邮箱:</div>
          <div class="input-msg">
            <input type="text" placeholder="请输入您的邮箱" v-model="addr" maxlength="25" />
          </div>
        </div>
        <div class="input-box van-hairline--surround mb4" v-else>
          <div class="input-title">地址:</div>
          <div class="input-msg">
            <input type="text" placeholder="请输入您的地址" v-model="addr" maxlength="20" />
          </div>
        </div>
        <button class="sumbit" @click.stop="submitMsg">确定</button>
      </div>
      <img src="../assets/cancle.png" alt="cancle" class="cancle" @click.stop="closeLogin" />
    </div>
  </van-popup>
</template>

<script>
import { fill_address } from "../config";
export default {
  name: "Bingo",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    gift: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data: () => ({
    username: "",
    phone_number: "",
    addr: ""
  }),
  computed: {
    kaiguan: {
      get: function() {
        return this.show === true;
      },
      set: function() {
        return;
      }
    }
  },
  methods: {
    closeLogin() {
      this.$emit("changelogin");
    },
    submitMsg() {
      if (!this.username || !this.phone_number || (!this.addr && !this.email)) {
        this.$toast({
          type: "fail",
          message: "请填写完整信息",
          duration: 800
        });
        return;
      }
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "get",
        url: fill_address,
        params: {
          drawId: this.gift.id || this.gift.drawId,
          name: this.username,
          phone: this.phone_number,
          address: this.addr
        }
      }).then(res => {
        let that = this;
        let { data } = res;
        if (data.code === 0) {
          this.$toast({
            type: "success",
            message: data.msg,
            duration: 800,
            onClose: function() {
                that.username='';
                that.phone_number='';
                that.addr='';
              that.closeLogin();
            }
          });
        } else {
          this.$toast({
            type: "fail",
            message: data.msg,
            duration: 800
          });
          return;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.bingo {
  .box-content {
    padding: 40px;
    width: 580px;
    background-color: #112b5d;
    color: #fff;
    position: relative;
    margin-bottom: 30px;
    .title {
      text-align: center;
      margin-bottom: 40px;
    }
    .input-box {
      padding: 20px;
      display: flex;
      .input-title {
        font-size: 28px;
        color: #fff;
        width: 100px;
        text-align: center;
      }
      .input-msg {
        padding-left: 10px;
        flex: 1;
        font-size: 28px;
        display: flex;
        align-items: center;
        input {
          color: #fff;
        }
        input::placeholder {
          color: #fff;
        }
      }
    }
    .mb2 {
      margin-bottom: 20px;
    }
    .mb4 {
      margin-bottom: 40px;
    }
    .sumbit {
      cursor: pointer;
      width: 100%;
      border-radius: 10px;
      height: 80px;
      background-color: #00d5d4;
      color: #000;
    }
  }
  .cancle {
    cursor: pointer;
    display: block;
    margin:0 auto;
    width: 45px;
    height: 45px;
  }
}
</style>
